import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfidence80 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.79484 6.2644C3.31388 7.95155 2.41602 10.1632 2.41602 12.5845",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.55664 14.2285C3.02204 16.921 4.6108 19.2287 6.82276 20.6514",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5918 21.0001C19.1057 19.6257 20.9361 17.1576 21.4434 14.2356",
			stroke: "var(--progress-track-bg, #CEDBDD)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5858 12.5846C21.5858 10.2617 20.7595 8.13186 19.3848 6.4729",
			stroke: "var(--progress-track-bg, #CEDBDD)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4125 5.46017C16.7142 3.93081 14.4662 3 12.0008 3C9.67411 3 7.54101 3.82908 5.88086 5.20794",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.14 12.29C10.5 12.4233 10.7933 12.6467 11.02 12.96C11.2467 13.2733 11.36 13.6533 11.36 14.1C11.36 14.7 11.1233 15.18 10.65 15.54C10.1767 15.9 9.58 16.08 8.86 16.08C8.14 16.08 7.54667 15.8967 7.08 15.53C6.61333 15.1633 6.38 14.6867 6.38 14.1C6.38 13.6533 6.49 13.2733 6.71 12.96C6.93667 12.6467 7.23 12.4233 7.59 12.29V12.27C7.36333 12.1767 7.16333 12 6.99 11.74C6.81667 11.4733 6.73 11.1733 6.73 10.84C6.73 10.28 6.93 9.84333 7.33 9.53C7.73 9.21 8.24 9.05 8.86 9.05C9.49333 9.05 10.0067 9.21 10.4 9.53C10.8 9.85 11 10.2867 11 10.84C11 11.1733 10.9133 11.4733 10.74 11.74C10.5733 12 10.3733 12.1767 10.14 12.27V12.29ZM9.49 10.4C9.32333 10.2467 9.11333 10.17 8.86 10.17C8.60667 10.17 8.39667 10.25 8.23 10.41C8.07 10.5633 7.99 10.75 7.99 10.97C7.99 11.1967 8.07 11.3833 8.23 11.53C8.39667 11.67 8.60667 11.74 8.86 11.74C9.12 11.74 9.33 11.67 9.49 11.53C9.65667 11.3833 9.74 11.1967 9.74 10.97C9.74 10.7433 9.65667 10.5533 9.49 10.4ZM8.86 14.92C9.18667 14.92 9.45333 14.8233 9.66 14.63C9.86667 14.4367 9.97 14.2 9.97 13.92C9.97 13.6267 9.86667 13.3867 9.66 13.2C9.45333 13.0133 9.18667 12.92 8.86 12.92C8.53333 12.92 8.26667 13.0133 8.06 13.2C7.85333 13.3867 7.75 13.6267 7.75 13.92C7.75 14.2067 7.85667 14.4467 8.07 14.64C8.28333 14.8267 8.54667 14.92 8.86 14.92ZM15.5649 16.08C14.7649 16.08 14.1183 15.77 13.6249 15.15C13.1383 14.5233 12.8949 13.6633 12.8949 12.57C12.8949 11.51 13.1349 10.66 13.6149 10.02C14.0949 9.37333 14.7449 9.05 15.5649 9.05C16.3783 9.05 17.0283 9.36333 17.5149 9.99C18.0016 10.6167 18.2449 11.4767 18.2449 12.57C18.2449 13.63 18.0049 14.48 17.5249 15.12C17.0449 15.76 16.3916 16.08 15.5649 16.08ZM14.6249 14.22C14.8583 14.62 15.1749 14.82 15.5749 14.82C15.9749 14.82 16.2883 14.6267 16.5149 14.24C16.7416 13.8467 16.8549 13.29 16.8549 12.57C16.8549 11.87 16.7416 11.32 16.5149 10.92C16.2883 10.52 15.9749 10.32 15.5749 10.32C15.1749 10.32 14.8583 10.5167 14.6249 10.91C14.3983 11.2967 14.2849 11.85 14.2849 12.57C14.2849 13.2633 14.3983 13.8133 14.6249 14.22Z",
			fill: "var(--label-color, #475B5E)"
		})
	]
});
export default SvgConfidence80;
